<script setup lang="ts">
import FormInputField from './FormInputField.vue'
import FormDropdown from '../dropdowns/FormDropdown.vue'
import { ref } from 'vue'

const value = defineModel('value')
const unit = defineModel('unit')

defineProps<{
  units: { value: number; title: string }[]
}>()

const inputRef = ref(null)

const handleFocus = (event: FocusEvent) => {
  const target = event.target as HTMLInputElement
  if (target && target.select && (target.value === '0' || value.value === 0)) {
    setTimeout(() => {
      target.select()
    }, 0)
  }
}
</script>
<template>
  <FormInputField 
    ref="inputRef"
    class="form-input-with-unit-field" 
    v-bind="$attrs" 
    v-model="value"
    @focus="handleFocus"
  >
    <template #append>
      <FormDropdown
        class="unit-dropdown"
        :items="units"
        readonly
        item-value="title"
        hide-details
        placeholder="Unit"
        min-width="80"
        v-model="unit"
      />
    </template>
  </FormInputField>
</template>
